<template>
    <div :class="scoreCellCss">
        <span v-if="showAverage"> {{ Math.round(floatAverage * 100) }}% </span>
        <span v-else>--</span>
    </div>
</template>
<script>
export default {
    name: "StudentScoreBox",
    props: {
        percentAverage: {
            type: [Number, String],
            default: 0,
        },
        showAverage: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        scoreCellCss() {
            let css = "rounded text-center border p-1.5 py-1.5" + " ";

            if (!this.showAverage) {
                css += "text-gray-525 border-gray-325";
            } else if (this.floatAverage >= 0.85) {
                css += "text-green-525 border-green-325";
            } else if (this.floatAverage >= 0.7) {
                css += "text-orange-625 border-orange-325";
            } else {
                css += "text-red-525 border-red-225";
            }

            return css;
        },
        floatAverage() {
            return parseFloat(this.percentAverage);
        },
    },
};
</script>
